module.exports = __webpack_public_path__ + "static/media/point-click.2dcebd49.svg";